import {
    ChevronEndIcon,
    Divider,
    Dropdown,
    Flex,
    InfoIcon,
    Skeleton,
    Text,
    Tooltip,
} from "@fluentui/react-northstar";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import styled from "styled-components/macro";
import {
    Calculator24Regular,
    CalculatorArrowClockwise24Regular,
    Calendar24Regular,
    CalendarClock24Regular,
} from "@fluentui/react-icons";
import { useQuery } from "react-query";
import { get_user_leave_data } from "../../../../../features/leave/api";
import moment from "moment";
import { DEVICE } from "../../../../../constants/responsive";

const DetailedLeaveUserSolde = ({
    employee_data,
    id_employee,
    SimulateLeaveSolde,
    isLoadingBalanceType,
    isFetchingBalanceType,
    refetchBalanceType,
}) => {
    // * STATES
    // * STATES
    // * STATES
    const [balanceColor, setBalanceColor] = useState(null);
    const [selectedDate, setSelectedDate] = useState({
        month: null,
        year: null,
        balance_id: null,
    });

    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    const {
        data: dataDependType,
        isLoading,
        isFetching,
    } = useQuery(
        [
            "getUserLeaveSolde",
            {
                id_user: id_employee,
                ...selectedDate,
            },
        ],
        (data) => {
            const payload = data.queryKey[1];
            return get_user_leave_data(payload);
        },
        {
            enabled: !!selectedDate.balance_id,
        }
    );

    const period_start_date = moment(dataDependType?.period_start_date)
        .locale("fr")
        .format("MMMM YYYY");
    const period_end_date = moment(dataDependType?.period_end_date)
        .locale("fr")
        .format("MMMM YYYY");

    // * FUNCTIONS
    // * FUNCTIONS
    // * FUNCTIONS
    const generateMonthsList = () => {
        let months = [];
        for (let i = 0; i < 12; i++) {
            const date = moment().add(i, "months");
            const monthName = date.format("MMMM"); // Nom du mois
            const monthNumber = date.format("M"); // Numéro du mois (1-12)
            const year = date.format("YYYY"); // Année

            months.push({
                key: `${monthNumber}-${year}`, // Clé unique
                header:
                    monthName.charAt(0).toUpperCase() +
                    monthName.slice(1) +
                    " " +
                    year, // Nom affiché
                month: monthNumber,
                year: year, // Stocker mois + année
            });
        }

        return [
            {
                key: `current-period`, // Clé unique
                header: "Aujourd'hui", // Nom affiché
                month: null, // Numéro du mois actuel
                year: null, // Stocker mois + année
            },
            ...months,
        ];
    };

    const handleLeaveTypeClick = (balance_id) => {
        refetchBalanceType();
        // scroll to bottom dialog

        return setSelectedDate((prev) => ({
            ...prev,
            balance_id: balance_id,
        }));
    };

    const handleChange = (value) => {
        SimulateLeaveSolde(value);
        if (!selectedDate.balance_id) {
            return console.log("no balance id selected");
        }
        setSelectedDate((prev) => {
            return {
                ...prev,
                month: value.month,
                year: value.year,
            };
        });
    };
    const SignValue = (value) => {
        if (value > 0) {
            return `+ ${value}`;
        } else {
            return `${value}`;
        }
    };

    //* CONSTANTS
    //* CONSTANTS
    //* CONSTANTS
    const monthsList = useMemo(() => generateMonthsList(), []);

    useEffect(() => {
        if (
            employee_data?.balances?.length > 0 &&
            selectedDate.balance_id === null
        ) {
            const firstBalance = employee_data.balances[0];
            setBalanceColor(firstBalance.leave_type_color);
            handleLeaveTypeClick(firstBalance.id);
        }
    }, [employee_data]); // déclenché quand employee_data arrive

    return (
        <Flex column fill>
            <Divider />
            <HeroCard>
                <Title content="Soldes d'absences" />
                <Flex gap="gap.medium" vAlign="center">
                    <Flex fill>
                        <Dropdown
                            styles={{ width: "100%" }}
                            checkable
                            getA11ySelectionMessage={{
                                onAdd: (item) => `${item} has been selected.`,
                            }}
                            fluid
                            inverted
                            items={monthsList}
                            // defaultValue={selectedDate.month} // Sélectionne le mois actuel par défaut
                            placeholder={<PeriodeText content="Aujourd'hui" />}
                            onChange={(_, i) => handleChange(i.value)}
                        />
                    </Flex>
                    <Tooltip
                        trigger={<InfoIcon outline />}
                        content={
                            <Flex column gap="gap.small">
                                <Text content="Les absences validées et en attente sont soustraites de votre solde." />
                                <Flex column>
                                    <Text content="La simulation faite sur un mois prendra en compte votre solde à la fin du mois." />
                                    <Text
                                        content={
                                            <span>
                                                Exemple : une simulation en
                                                <b> juillet </b>
                                                vous montrera votre acquisition
                                                au
                                                <b> 31/07</b>
                                            </span>
                                        }
                                    />
                                </Flex>
                            </Flex>
                        }
                        subtle={false}
                        pointing
                        position="below"
                        align="end"
                    />
                </Flex>
            </HeroCard>
            <CardContent>
                <LeftContent>
                    {employee_data?.balances?.map((balance) => {
                        return (
                            <Fragment key={balance.id}>
                                <AbsenceType
                                    onClick={() => {
                                        setBalanceColor(
                                            balance?.leave_type_color
                                        );
                                        handleLeaveTypeClick(balance.id);
                                    }}
                                    $active={
                                        selectedDate.balance_id === balance.id
                                    }
                                    $dividerColor={balance?.leave_type_color}
                                    // gap="gap.medium"
                                    // space="between"
                                    vAlign="center"
                                >
                                    <LeaveTypeFlex column>
                                        {isLoadingBalanceType ||
                                        isFetchingBalanceType ? (
                                            <Skeleton animation="pulse">
                                                <Skeleton.Line
                                                    width="80px"
                                                    height="20px"
                                                />
                                            </Skeleton>
                                        ) : (
                                            <LeaveName
                                                content={balance?.name}
                                            />
                                        )}
                                        {isLoadingBalanceType ||
                                        isFetchingBalanceType ? (
                                            <Skeleton animation="pulse">
                                                <Skeleton.Line
                                                    width="80px"
                                                    height="20px"
                                                />
                                            </Skeleton>
                                        ) : (
                                            <LeaveCounter
                                                content={balance?.current_value}
                                            />
                                        )}
                                    </LeaveTypeFlex>
                                    <Flex>
                                        {selectedDate.balance_id ===
                                            balance.id && <ChevronEndIcon />}
                                    </Flex>
                                </AbsenceType>
                            </Fragment>
                        );
                    })}
                </LeftContent>
                {!!dataDependType?.start_month && (
                    <RightContent fill column>
                        <HeaderRightContent
                            $activeBackground={balanceColor}
                            space="between"
                        >
                            <Flex
                                styles={{
                                    color: "white",
                                    width: "78%",
                                }}
                                column
                            >
                                <TitleRightContent content="Détails du solde" />

                                {dataDependType.is_remote ? (
                                    <DescriptionRightContent
                                        content={`Période d’acquisition  : ${moment(
                                            dataDependType.remote_aquisition_period
                                        ).format("MMMM YYYY")}`}
                                    />
                                ) : (
                                    <DescriptionRightContent
                                        content={`Période d’acquisition : ${period_start_date} - ${period_end_date}`}
                                    />
                                )}
                            </Flex>
                            <EnJourFlex vAlign="center">
                                <Text content="en jours" />
                            </EnJourFlex>
                        </HeaderRightContent>

                        <RightContentDetail
                            $activeBackground={balanceColor}
                            column
                        >
                            {/* one row  */}
                            {!dataDependType?.is_remote && (
                                <Flex gap="gap.medium">
                                    <IconFlex vAlign="center" hAlign="center">
                                        <CalculatorArrowClockwise24Regular
                                            color={"#5b5fc7"}
                                        />
                                    </IconFlex>
                                    <Flex column>
                                        <TitleRow content="Report période précédente" />

                                        {isLoadingBalanceType ||
                                        isFetchingBalanceType ||
                                        isLoading ||
                                        isFetching ? (
                                            <Skeleton animation="pulse">
                                                <Skeleton.Text
                                                    size="medium"
                                                    styles={{ width: "30px" }}
                                                />
                                            </Skeleton>
                                        ) : (
                                            <CurrentValue
                                                color={"#5b5fc7"}
                                                content={SignValue(
                                                    dataDependType.previous_balance_report
                                                )}
                                            />
                                        )}
                                    </Flex>
                                </Flex>
                            )}
                            {/* second row  */}
                            <Flex gap="gap.medium">
                                <IconFlex vAlign="center" hAlign="center">
                                    <Calculator24Regular color={"#5b5fc7"} />
                                </IconFlex>
                                <Flex column>
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: "8px",
                                        }}
                                    >
                                        <p>Acquis</p>
                                        {dataDependType?.total_value_details && (
                                            <Tooltip
                                                subtle={false}
                                                content={
                                                    dataDependType?.total_value_details
                                                }
                                                trigger={<InfoIcon outline />}
                                            />
                                        )}
                                    </div>
                                    {isLoadingBalanceType ||
                                    isFetchingBalanceType ? (
                                        <Skeleton animation="pulse">
                                            <Skeleton.Text
                                                size="medium"
                                                styles={{ width: "30px" }}
                                            />
                                        </Skeleton>
                                    ) : (
                                        <CurrentValue
                                            color={"#5b5fc7"}
                                            content={dataDependType.total_value}
                                        />
                                    )}
                                </Flex>
                            </Flex>
                            {/* third row  */}
                            <Flex gap="gap.medium">
                                <IconFlex vAlign="center" hAlign="center">
                                    <Calendar24Regular />
                                </IconFlex>
                                <Flex column>
                                    <TitleRow content={`Absences validées`} />
                                    {isLoadingBalanceType ||
                                    isFetchingBalanceType ? (
                                        <Skeleton animation="pulse">
                                            <Skeleton.Text
                                                size="medium"
                                                styles={{ width: "30px" }}
                                            />
                                        </Skeleton>
                                    ) : (
                                        <CurrentValue
                                            color={"black"}
                                            content={
                                                dataDependType.approved_leave_balance ===
                                                0
                                                    ? dataDependType.approved_leave_balance
                                                    : `- ${dataDependType.approved_leave_balance}`
                                            }
                                        />
                                    )}
                                </Flex>
                            </Flex>
                            {/* fourth row  */}
                            <Flex gap="gap.medium">
                                <IconFlex vAlign="center" hAlign="center">
                                    <CalendarClock24Regular />
                                </IconFlex>
                                <Flex column>
                                    <TitleRow
                                        content={`Absences en attente de validation`}
                                    />
                                    {isLoadingBalanceType ||
                                    isFetchingBalanceType ? (
                                        <Skeleton animation="pulse">
                                            <Skeleton.Text
                                                size="medium"
                                                styles={{ width: "30px" }}
                                            />
                                        </Skeleton>
                                    ) : (
                                        <CurrentValue
                                            color={"black"}
                                            content={
                                                dataDependType.remaining_leave_balance ===
                                                0
                                                    ? dataDependType.remaining_leave_balance
                                                    : ` - ${dataDependType.remaining_leave_balance}`
                                            }
                                        />
                                    )}
                                </Flex>
                            </Flex>
                        </RightContentDetail>
                    </RightContent>
                )}
            </CardContent>
        </Flex>
    );
};

export default DetailedLeaveUserSolde;

const HeroCard = styled(Flex)`
    justify-content: space-between;
    gap: 16px;

    @media ${DEVICE.mobileS} {
        flex-direction: column;
        padding: 8px 16px;
        align-items: flex-start;
    }
    @media ${DEVICE.mobileM} {
        flex-direction: row;
        align-items: center;
    }
    @media ${DEVICE.tablet} {
        flex-direction: row;
        padding: 16px 32px;
    }
`;

const CurrentValue = styled(Text)`
    color: ${(props) => props.color};

    font-family: "Segoe UI";
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
`;

const TitleRow = styled(Text)`
    color: #242424;
    font-family: "Segoe UI";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`;

const IconFlex = styled(Flex)`
    border-radius: 4px;
    background: #f5f5f5;
    width: 48px;
    height: 48px;
    padding: 12px;
`;

const RightContentDetail = styled(Flex)`
    padding: 12px 24px 24px 24px;
    border-radius: 0px 0px 8px 8px;
    max-height: 308px;
    /* border: 2px solid #e6808a; */
    border: 2px solid ${(props) => props.$activeBackground};
    gap: 16px;
`;

const DescriptionRightContent = styled(Text)`
    color: #fff;
    font-family: "Segoe UI";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    flex-wrap: wrap;
`;

const TitleRightContent = styled(Text)`
    color: #fff;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
`;

const EnJourFlex = styled(Flex)`
    padding: 6px 8px;
    border-radius: 16px;
    background: #fff;
    font-size: 12px;
    width: 59px;
    height: 28px;
`;

const Title = styled(Text)`
    color: #242424;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;

    @media ${DEVICE.mobileS} {
        font-size: 14px;
    }
    @media ${DEVICE.mobileM} {
        font-size: 15px;
    }
    @media ${DEVICE.tablet} {
        font-size: 18px;
    }
`;

const PeriodeText = styled(Text)`
    color: #0067b8;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
`;

const LeftContent = styled(Flex)`
    flex-wrap: wrap;

    @media ${DEVICE.mobileS} {
        flex-direction: row;
        gap: 6px;
    }
    @media ${DEVICE.tablet} {
        flex-direction: column;
        gap: 16px;
    }
`;
const CardContent = styled(Flex)`
    gap: 24px;
    padding-top: 16px;

    @media ${DEVICE.mobileS} {
        flex-direction: column;
    }
    @media ${DEVICE.tablet} {
        flex-direction: row;
    }
`;

const AbsenceType = styled(Flex)`
    padding: 16px;
    border-radius: 8px;
    background: ${(props) => (props.$active ? "#EBEBEB" : "inherit")};
    width: 176px;
    height: 100px;
    cursor: pointer;
    &:before {
        border-radius: 16px;
        content: "";
        display: block; /* Makes it respect width & height */
        width: 8px;
        height: 100%;
        background: ${(props) => props.$dividerColor};
        flex-shrink: 0; /* Prevents shrinking inside flex */
    }
`;

const LeaveName = styled(Text)`
    color: #242424;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;

const LeaveCounter = styled(Text)`
    color: #242424;
    font-family: "Baloo Bhaijaan 2";
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    cursor: pointer;
`;

const LeaveTypeFlex = styled(Flex)`
    padding-left: 8px;
    gap: 12px;
    width: 176px;
`;

const RightContent = styled(Flex)``;

const HeaderRightContent = styled(Flex)`
    border-radius: 8px 8px 0px 0px;
    /* background: #e6808a; */
    background: ${(props) => props.$activeBackground};

    padding: 12px;
`;
